import { useTerminalsState } from "@/States/Terminals";
import { useTrans } from "@/translations";

export const ContaminationHeader = () => {
  const { t } = useTrans();
  const { currentTerminal } = useTerminalsState();

  return (
    <div>
      <div className="align-center ml-[20px] flex">
        <div className="flex flex-col justify-between">
          <div className="font-signifier height-[42px] text-[40px] leading-[42px]">
            {t("contaminationPage:title")}
          </div>
          <div className="font-dm-sans text-grey6 mt-[4px] flex items-center text-[13.5px]">
            {t("contaminationPage:subTitle", {
              buildingName: currentTerminal?.name,
              interpolation: { escapeValue: false },
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
